'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotScatter3dIcon = function PlotScatter3dIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M17.313 5.313h-2.625v8L0 18.688l16 8 16-8-14.688-5.375zM9 20a1.68 1.68 0 0 1-1.688-1.688c0-.875.75-1.625 1.688-1.625s1.688.75 1.688 1.625A1.68 1.68 0 0 1 9 20zm6.688 4.688C14.75 24.688 14 23.938 14 23s.75-1.688 1.688-1.688c.875 0 1.625.75 1.625 1.688s-.75 1.688-1.625 1.688zm8-7.375c.875 0 1.625.75 1.625 1.688s-.75 1.688-1.625 1.688c-.938 0-1.688-.75-1.688-1.688s.75-1.688 1.688-1.688zm-5-1c0 .938-.75 1.688-1.688 1.688s-1.688-.75-1.688-1.688c0-.875.75-1.625 1.688-1.625s1.688.75 1.688 1.625zM5.313 7c0 .938-.75 1.688-1.625 1.688C2.75 8.688 2 7.938 2 7s.75-1.688 1.688-1.688c.875 0 1.625.75 1.625 1.688zM12 11.688c0 .875-.75 1.625-1.688 1.625-.875 0-1.625-.75-1.625-1.625 0-.938.75-1.688 1.625-1.688.938 0 1.688.75 1.688 1.688zm-8.687 2c0 .875-.75 1.625-1.625 1.625-.938 0-1.688-.75-1.688-1.625C0 12.75.75 12 1.688 12c.875 0 1.625.75 1.625 1.688zm26.687 0c0 .875-.75 1.625-1.688 1.625-.875 0-1.625-.75-1.625-1.625 0-.938.75-1.688 1.625-1.688.938 0 1.688.75 1.688 1.688zM23.313 9c0 .938-.75 1.688-1.625 1.688C20.75 10.688 20 9.938 20 9s.75-1.688 1.688-1.688c.875 0 1.625.75 1.625 1.688zM32 7a1.68 1.68 0 0 1-1.688 1.688c-.875 0-1.625-.75-1.625-1.688s.75-1.688 1.625-1.688C31.25 5.312 32 6.062 32 7z' })
    );
};

exports.default = PlotScatter3dIcon;